import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {Button} from "primereact/button";
import {Divider} from "@material-ui/core";
import NumberFormat from "react-number-format";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const ExchangeView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{
                       paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%',
                       overflow: 'auto'
                   }}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <div className="p-col-8">
                        <TitlePage title="Administración \ Ejercicio de Derechos \ Canje"/>
                    </div>
                    <div className="p-col-4" align="right">
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnCorporateActionPage}/>&nbsp;
                        <Button label="Guardar" onClick={props.applyCorporateAction}/>
                    </div>
                    <div className="p-col-12"> <Divider/> </div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Emisora" isBold={true}/>
                        <SubtitleLabel header={props.dataCorporateAction.fullInstrument}/>
                    </div>
                    <div className="p-col-12">
                        <SubtitleLabel header="Descripción" isBold={true}/>
                        <SubtitleLabel header={props.dataCorporateAction.descrCorporateAction}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Ratio" isBold={true}/>
                        <NumberFormat decimalScale={2}
                                      id={3} name="ratio"
                                      required={true}
                                      customInput={InputText}
                                      value={props.ratio}
                                      onChange={props.handleChangeValue}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Emisora Nueva" isBold={true}/>
                        <Dropdown placeholder="Seleccione..."
                                  name="newInstrument"
                                  filter={true}
                                  filterBy="fullInstrument"
                                  optionLabel="fullInstrument"
                                  options={props.instruments}
                                  value={props.instrumentObject}
                                  onChange={props.handleChangeValue}/>
                    </div>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ExchangeView;